export enum RepeatEnd {
  none = '',
  continueIndefinitely = 'CONTINUE_INDEFINITELY',
  endDate = 'END_DATE',
}

export enum EventDialogMode {
  Create = 'create',
  EditNonRecurring = 'edit-non-recurring',
  EditRecurring = 'edit-recurring',
}
